import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormRushRadioDuoField, {
  MxFormRushRadioDuoFieldprops
} from "@rf-l2/form/rush/MxFormRushRadioDuoField";

interface MxFormL3RushRadioDuoFieldProps extends MxFormRushRadioDuoFieldprops {
  name: string;
  withreacthookform?:1|0;
}
const MxFormL3RushRadioDuoField = (props: MxFormL3RushRadioDuoFieldProps) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormRushRadioDuoField {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3RushRadioDuoField;
